// utils/wechatQrcodes.js
// 企业微信二维码：从 SDS-Admin 公开端点拉取本项目(nvivoai)后台配置的 C 端 / B 端二维码图。
// 与 membership_intro / agreements 同款公开端点模式（无鉴权、跨域）。
//   cEnd —— 面向个人用户（客服 / 咨询 / 专人定制）的二维码
//   bEnd —— 面向机构客户（私有部署顾问）的二维码
// 图片以「图片外链 URL」或「base64 data URL」字符串下发，<img :src> 通吃；未配置则为空串，
// 各投放点回退到内置默认图。模块级共享：首次被任意组件 import 即自动拉取，结果缓存，全站仅一次请求。
// NVivo 为 Vue 2.6（无 Composition API），用 Vue.observable 实现响应式。
import Vue from 'vue'
import { fetchSdsPublic } from './sdsPublic'

export const wechatQrcodes = Vue.observable({ cEnd: '', bEnd: '', loaded: false })

let _promise = null
export function ensureWechatQrcodes() {
  if (_promise) return _promise
  _promise = (async () => {
    const data = await fetchSdsPublic('wechat_qrcodes')
    if (data) {
      wechatQrcodes.cEnd = data.c_end || ''
      wechatQrcodes.bEnd = data.b_end || ''
    }
    wechatQrcodes.loaded = true
    return wechatQrcodes
  })()
  return _promise
}

// 首次 import 即自动拉取（memoized，仅一次网络请求）。
ensureWechatQrcodes()
